import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import FormRegistroEntradaSalida from '../../tramites/formularios/FormRegistroEntradaSalida';
import getRegistroEntradaSalidaPorId from '../../../graphql/querys/registroEntradaSalida/getRegistroEntradaSalidaPorId.graphql';
import updateRegistroEntradaSalidaPorId from '../../../graphql/mutations/registroEntradaSalida/updateRegistroEntradaSalidaPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(updateRegistroEntradaSalidaPorId, {
    name: 'updateRegistroEntradaSalidaPorId',
  }),
  graphql(getUsuario)
)
class EditarRegistroEntradaSalida extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      declarante: {},
      certificacion: {},
      ente_receptor: '',
      declaracion: '',
      fecha_creacion: '',
      step: 0,
      guardado: false,
      loading: true,
    };

    this.props.client
      .query({
        query: getRegistroEntradaSalidaPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const registro = res.data.getRegistroEntradaSalidaPorId;

        this.setState({
          loading: false,
          ...registro,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.onCancel = this.onCancel.bind(this);
    this.guardarDatosRegistro = this.guardarDatosRegistro.bind(this);
  }

  guardarDatosRegistro(datos) {
    let data = {
      ...datos,
      fechaDevolucion: datos.fechaDevolucion
        ? datos.fechaDevolucion.toDate()
        : null,
      fechaRecepcion: datos.fechaRecepcion
        ? datos.fechaRecepcion.toDate()
        : null,
    };

    this.props
      .updateRegistroEntradaSalidaPorId({
        variables: { _id: this.state._id, nuevoRegistroEntradaSalida: data },
      })
      // eslint-disable-next-line no-unused-vars
      .then(resRegistro => {
        notification.success({
          message: 'Actualizacion Correcta',
          description:
            'Se ha registrado los nuevos datos de la declaracion jurada',
        });

        this.props.history.push('/');
      })
      .catch(err => {
        console.log('ERROR: ', err);
        errorService(err, {
          _id: this.state._id,
          nuevoRegistroEntradaSalida: data,
        });
      });
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  siguientePaso() {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Registro Entrada Salida</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Registro de Entrada y/o Salida
          </h2>
          <br />
          <div style={estiloContent}>
            <FormRegistroEntradaSalida
              onSubmit={this.guardarDatosRegistro}
              datos={{
                fechaRecepcion: this.state.fechaRecepcion,
                fechaDevolucion: this.state.fechaDevolucion,
                organismoOrigen: this.state.organismoOrigen,
                descripcion: this.state.descripcion,
              }}
              config={{ creacion: false }}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarRegistroEntradaSalida);
